<script>
  import { M } from '../../external';
  import { onMount } from 'svelte';
  import ProductReviewService, { HttpError } from './service';

  // We do not want to call the API on every change, so we will keep the changes in a local object
  let changeSet = {};

  export const saveChanges = () => {
    ProductReviewService.partialUpdateContext(changeSet);
    changeSet = {};
  };

  const roleOptions = [
    { value: 0, name: M.ONLY_ADMINS },
    { value: 1, name: M.ADMINS_MODERATORS },
    { value: 2, name: M.ALL_MEMBERS }
  ];

  let defaultContext = {
    resourceType: 'product_review',
    name: '',
    moderation: { writePermission: 0, approvalRequired: 0 },
    commentModeration: { writePermission: 0, approvalRequired: 0 },
    extra: {
      allowMentions: false,
      enabled: false,
      allowImages: false,
      headerStyle: 'alpha',
      notifyOnReply: 'ONLY_FIRST_DEPTH'
    }
  };

  const onContextUpdated = (partialUpdate) => {
    changeSet = { ...changeSet, ...partialUpdate };
  };

  const checkIfContextIsOutdated = () => {
    if (!defaultContext.extra.notifyOnReply) {
      if (confirm('Context out-of-date. \'notifyOnReply\' is not set. Do you want me to upgrade?')) {
        onContextUpdated({ extra: { notifyOnReply: 'ONLY_FIRST_DEPTH' } });
        saveChanges();
      }
    }
  };

  onMount(async () => {
    try {
      defaultContext = await ProductReviewService.getDefaultContext();
    } catch (error) {
      if (error instanceof HttpError) {
        // First time visitor to this page, no default context yet, create a new one
        if (error.statusCode === 404) {
          console.warn(error.message);
          defaultContext = await ProductReviewService.createDefaultContext();
        }
      }
    } finally {
      checkIfContextIsOutdated();
    }
  });
</script>

<div class="popup-widget-wrapper">
  <div class="sections-wrapper">
    <section>
      <div class="checkbox-wrapper">
        <input
          id="enabled"
          bind:checked={defaultContext.extra.enabled}
          on:change={() => {
            onContextUpdated({ extra: { enabled: defaultContext.extra.enabled } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="enabled" />
        <label for="enabled" class="css-label button-tooltip" data-original-title="" title="">{M.REVIEW_ENABLED}
          <p>{M.REVIEW_ENABLE_DESC}</p>
        </label>
      </div>
    </section>
    <!--<section>
      <div class="info">
        <h4>{M.REVIEW_HEADER_STYLE_LABEL}</h4>
        <span class="col20 f-left light-gray-text mb-10 mt-5">{M.REVIEW_HEADER_STYLE_DESC}</span>
        <select
          class="button-size-select"
          name="order"
          bind:value={defaultContext.extra.headerStyle}
          on:change={() => {
            onContextUpdated({ extra: { headerStyle: defaultContext.extra.headerStyle } });
          }}
          style="width: 100%">
          <option value="alpha">Alpha</option>
          <option value="beta">Beta</option>
        </select>
      </div>
    </section>-->
    <section>
      <div class="checkbox-wrapper">
        <input
          id="isModerationEnabled"
          checked={defaultContext.moderation?.approvalRequired < 2}
          on:change={(event) => {
            event.target.checked
              ? onContextUpdated({ moderation: { approvalRequired: 1 } })
              : onContextUpdated({ moderation: { approvalRequired: 2 } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="isModerationEnabled" />
        <label for="isModerationEnabled" class="css-label button-tooltip" data-original-title="" title=""
        >{M.REVIEW_REQUIRE_APPROVAL}</label>
      </div>
    </section>
    <section class="mt-10">
      <div class="info">
        <h5>{M.SOCIAL_WHO_CAN_REPLY}</h5>
      </div>
      <select
        class="col20 f-left"
        bind:value={defaultContext.commentModeration.writePermission}
        on:change={() => {
          onContextUpdated({
            commentModeration: { writePermission: defaultContext.commentModeration.writePermission }
          });
        }}>
        {#each roleOptions as option}
          <option value={option.value}>{option.name}</option>
        {/each}
      </select>
    </section>
    <section class="mt-10">
      <div class="checkbox-wrapper">
        <input
          id="commentIsModerationEnabled"
          checked={defaultContext.commentModeration.approvalRequired < 2}
          on:change={(event) => {
            event.target.checked
              ? onContextUpdated({ commentModeration: { approvalRequired: 1 } })
              : onContextUpdated({ commentModeration: { approvalRequired: 2 } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="commentIsModerationEnabled" />
        <label for="commentIsModerationEnabled" class="css-label button-tooltip">{M.SOCIAL_REQUIRE_REPLY_APPROVAL}</label>
      </div>
    </section>
    <section>
      <div class="checkbox-wrapper">
        <input
          id="allowImages"
          bind:checked={defaultContext.extra.allowImages}
          on:change={() => {
            onContextUpdated({ extra: { allowImages: defaultContext.extra.allowImages } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="allowImages" />
        <label for="allowImages" class="css-label button-tooltip">{M.ALLOW_IMAGES}</label>
      </div>
    </section>
  </div>
</div>
